import {AsyncStorage, StorageKey} from './storage';
import axios from 'axios';

export class RemoteStorage implements AsyncStorage {
    private cache = {};

    public getItem = <T>(key: StorageKey, defaultValue: T): Promise<T> => {
        const cacheKey = key.cacheId;
        if (this.cache[cacheKey] !== undefined) {
            return Promise.resolve(this.cache[cacheKey]);
        }
        return this.getItemUnCached(key, defaultValue).then((value) => (this.cache[cacheKey] = value));
    };

    private getItemUnCached = <T>(key: StorageKey, defaultValue: T): Promise<T> => {
        return axios
            .get(key.endpoint)
            .then((response) => response.data)
            .catch((error) => {
                if (error && error.response && error.response.status === 404) {
                    return Promise.resolve(defaultValue);
                }
                return Promise.reject(error);
            });
    };

    public setItem = (key: StorageKey, value: string | object): Promise<void> => {
        this.cache[key.cacheId] = value;
        return axios.post(key.endpoint, value).then(() => {});
    };

    public clearCache = () => {
        this.cache = {};
    };
}



// WEBPACK FOOTER //
// ./src/storage/RemoteStorage.ts